import { GridCellParams, GridColDef } from '@mui/x-data-grid-pro';
import { PointConfigRef } from '@src/types/Widget';
import { useMemo } from 'react';
import { getColumns } from '../columnUtils';

interface UseDeviceTableColumnsOptions {
  pointConfigRefs: PointConfigRef[];
  enableCmdBtnColumn?: boolean;
  enableNotesColumn?: boolean;
  customColumn?: (params: GridCellParams) => React.ReactNode;
  disableButton?: boolean;
  disabledByInterlock?: boolean;
  openCmdModal?: (deviceId: string) => void;
  alias?: (text: string) => string;
}

const useDeviceTableColumns = ({
  pointConfigRefs,
  enableCmdBtnColumn,
  enableNotesColumn,
  customColumn,
  disableButton,
  disabledByInterlock,
  openCmdModal,
  alias,
}: UseDeviceTableColumnsOptions): GridColDef[] =>
  useMemo(
    () =>
      getColumns(
        pointConfigRefs,
        enableCmdBtnColumn,
        enableNotesColumn,
        customColumn,
        disableButton,
        disabledByInterlock,
        openCmdModal,
        alias,
      ),
    [
      pointConfigRefs,
      enableCmdBtnColumn,
      enableNotesColumn,
      customColumn,
      disableButton,
      disabledByInterlock,
      openCmdModal,
      alias,
    ],
  );

export default useDeviceTableColumns;
